import styled from '@emotion/styled'
export const StyleHeaderWrapper = styled.div`
  height: 80px;
  width: 100%;
  background: ${(props: any) => props.theme.colors.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.inputBorder};
`

export const StyleHeaderImageWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`
